import { Section } from "../../../../patterns/Section.js";
import type { PageLayoutProps } from "../../../contract.js";
import type { BattlesLobbyContent } from "../../battlesContent.js";

/**
 * The battles lobby, showroom layout: the title beside Create, the
 * filter chips, then the cards three across. On phones Create sits under the title and the cards
 * stack.
 */
export function BattlesShowroomLayout({ sections }: PageLayoutProps<BattlesLobbyContent>) {
  return (
    <Section className="flex flex-col gap-6 pt-6 pb-20 md:gap-8 md:pt-10">
      {sections.heading}
      {sections.filter}
      {sections.list}
    </Section>
  );
}
